<div class="header-container">
  <nav class="navbar navbar-expand">
    <a class="navbar-brand" [routerLink]="getLogoRedirect()" [title]="applicationVersion">
      <img src="../assets/images/Alpi_2020_BW_F.png" alt="Alpi USA" />
    </a>
    <div class="collapse navbar-collapse" *ngIf="currentUser">
      <ul class="navbar-nav" *ngIf="showMenu()">
        <li class="nav-item" *ngIf="currentUser?.Role !== RolesEnum.CustomerRole">
  <a class="nav-link" [routerLinkActive]="['active']" routerLink="/consolidation" (click)="CleanCache()">Home</a>
</li>
        <li class="nav-item" *ngIf="currentUser?.Role !== RolesEnum.CustomerRole">
            <a class="nav-link" [routerLinkActive]="['active']" routerLink="/processing" (click)="CleanCache()">ISF Upload</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLinkActive]="['active']" routerLink="/tracking" (click)="CleanCache()">Tracking</a>
        </li>
        <li class="nav-item" *ngIf="showUserManagementMenuItem()">
          <a class="nav-link" [routerLinkActive]="['active']" routerLink="/administration/usermanagement" (click)="CleanCache()">User Management</a>
        </li>
        <li class="nav-item" *ngIf="showUserManagementMenuItem()">
          <a class="nav-link" [routerLinkActive]="['active']" routerLink="/admindashboard" (click)="CleanCache()">Admin Dashboard</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLinkActive]="['active']" routerLink="/quoterequest" (click)="CleanCache()">Request For Quote</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLinkActive]="['active']" routerLink="/terms">Terms And Conditions</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLinkActive]="['active']" routerLink="/contactus" (click)="CleanCache()">Contact Us</a>
        </li>
      </ul>
      <div class="navbar-text ml-auto">
<div ngbDropdown placement="bottom-left" class="user-dropdown">
  <button
    id="userProfileDropdown"
    type="button"
    class="current-user"
    ngbDropdownToggle
  >
    <span class="user-avatar">
      <i class="bi bi-person"></i>
    </span>

    <span class="user-name">
      {{ currentUser.FullName }}
    </span>

    </button>
        <div
          ngbDropdownMenu
          aria-labelledby="userProfileDropdown"
          class="user-dropdown-menu"
        >
          <button ngbDropdownItem (click)="logout()">
            Logout
          </button>
          <button ngbDropdownItem routerLink="/changepassword">
            Change Password
          </button>
        </div>
      </div>
    </div>

    </div>
    <div class="collapse navbar-collapse" *ngIf="!currentUser">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" [routerLinkActive]="['active']" routerLink="/tracker">Tracker</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLinkActive]="['active']" routerLink="/quoterequestguest">Request For Quote</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLinkActive]="['active']" routerLink="/termsguest">Terms And Conditions</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [routerLinkActive]="['active']" routerLink="/contactusguest">Contact Us</a>
        </li>
      </ul>
      <div class="navbar-text ml-auto">
        <button class="btn btn-link login-link" routerLink="/authentication" style="min-width: 100px">Staff Sign In</button>
        <button class="btn btn-link login-link" routerLink="/authentication/customer">Customer Sign In</button>
      </div>

    </div>
  </nav>
</div>
